// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"ddd096d0","outerContainer":"_19383066","secondaryToolbar":"_13c85f78","doorHangerRight":"ebd67a37","toolbarContainer":"_333d396c","toolbarViewerMiddle":"_6d0e3e67","progressBar":"_13a8eb67","back-to-application":"_80453320","consentItem":"_664cf8be","consentInfoWrapper":"_56c3e44c","icon":"_6b676d86","consentTitle":"_90901ef4","consentSubtitleRow":"_732b6128","consentSubTitle":"d5264715"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProfileLayout/ProfileDocumentation/RenderViewConsents/ViewConsent/index.styl
// module id = 5089
// module chunks = 39